import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Component from "./editable-component.js";
import {GridContainer} from "./grid.js";
import {media} from "./theme.js";
import ContentModules from "./content-modules.js";
import {Title} from "./typo.js";
export default function ContentPage(props) {
  const {headline, modules} = props;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Component, {
    ...props
  }, /* @__PURE__ */ React.createElement(GridContainer, null, /* @__PURE__ */ React.createElement(ContentTitle, {
    level: 1
  }, headline), modules && /* @__PURE__ */ React.createElement(ContentModules, {
    modules,
    isProductPage: false
  }))));
}
const Container = styled.div`
  padding-top: 80px;

  ${media.mobile} {
    padding-top: 32px;
  }
`;
const ContentTitle = styled(Title)`
  margin-bottom: 64px;

  ${media.mobile} {
    font-size: 30px;
    margin-bottom: 32px;
  }
`;
